import { isEmpty } from 'lodash';

export default function youtubeIdFromUrl(url: string): string | null {
  // const regex = /(?:youtube\.com|youtu\.be)\/(?:watch\?v=|shorts\/)?([\w-]+)/;
  const regex = /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu.be\/(?!shorts))([\w-]+)/;

  const matches = regex.exec(url);
  if (!(!matches
    || !Array.isArray(matches)
    || isEmpty(matches[1]))
  ) {
    return matches[1];
  }

  return null;
}
